<template>

  <div class="goods-list">
    <div
      class="goods-item GOODITEM"
      v-for="(item,index) in goodsList"
      @click="toGoodsDetail(item.itemId,index)"
      :key="index"
      :data-id="item.itemId"
    >
      <span :class="item.showTag && item.showTag === '首单专享' ? 'first-tag' : (item.showTag && item.showTag !== '首单专享' ? 'first-tag noshow' : '')"></span>
      <div class="goods-pic">
        <img :src="item.itemImg" />
      </div>
      <div class="bottom-detail">
        <p class="goods-title">{{item.itemName}}</p>
        <p v-if="item.discountTxt" class="marks discount">
          <span>{{item.discountTxt}}</span>
        </p>
        <p v-else-if="item.hotSaleTag" class="marks">
          <span>{{item.hotSaleTag}}</span>
        </p>
        <p v-else class="marks no-data">
          <span></span>
        </p>
        <div class="goods-price-block">
          <span class="new-price">
            <span class="price-sign">{{item.priceTxt}}<font>¥</font><font class="new-price-font">{{parseFloat(item.firstPrice || item.normalPrice)}}</font></span>
            <span class="old-price" v-if="item.normalPrice && item.firstPrice">
              <span class="old-price-sign">￥</span>
              <span class="old-price-value">{{item.normalPrice}}</span>
            </span>
          </span>
        </div>
      </div>
      <!-- <div class="buy-btn">立即购买</div> -->
    </div>
  </div>
</template>
<script>
import * as Util from '@/assets/js/Util'
import YunJi from '@/assets/js/YunJi'

export default {
  data() {
    return {
      ABtestId: YunJi.getUrlParams('ABtestId') || ''
    }
  },
  props: {
    goodsList: Array,
    shopId: String,
    tabName: String,
    tabCurrent: { //父组件传过来的city对象
        default: 0
      }
  },
  methods: {
    /**
     * 跳转商品详情页
     */
    toGoodsDetail(itemId, index) {
      const reportParam = {
        page_id: '80612',
        point_id: '26437',
        content_type: '',
        content_type: this.tabName,
        item_id: `${itemId}`,
        'ABtestId': this.ABtestId
      }
      thinkingReport.track('click_list', reportParam)
      let ids = Util.exposureThinkingReport()
      window.thinkingReport.track('exposure', {
        page_id: '80612',
        point_id: '26436',
        'ABtestId': this.ABtestId,
        content_type: this.tabName,
        item_id : ids.join(','),
        point_name : '离开曝光'
      })
      setTimeout(() => {
        if (Util.isWxProgram()) {
          wx.miniProgram.navigateTo({ url: `/pages/new-recommend/new-recommend?itemId=${itemId}&shopId=${this.shopId}&newRecommendSourceType=4` })
        }
      }, 50)
    },
     getAccumulativeSales(item) {
      if (!item) {
        return ''
      }
      if (!item.itemYearSales) {
        return ''
      }
      if (item.itemYearSales <= 1000) {
        return `${item.itemYearSales}`
      } 
      if (item.itemYearSales >= 100000) {
        return '10万+'
      }
      return `${parseInt(item.itemYearSales / 1000, 10) / 10}万`
    }
  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
.goods-list {
  padding-left: .24rem;
  overflow: hidden;
  .goods-item {
    float: left;
    margin-right: 0.15rem;
    margin-bottom: 0.16rem;
    width: 2.24rem;
    height: 4rem;
    background: #FFF;
    overflow: hidden;
    border-radius: 0.06rem;
    position: relative;

    .first-tag {
      position: absolute;
      top: 0;
      left: .14rem;
      width: .66rem;
      height: .66rem;
      display: block;
      background: url('../image/first.png') no-repeat; 
      background-size: 100% 100%;  
      &.new {
        background: url('../image/new.png') no-repeat; 
      }
    }
    .goods-pic {
      width: 2.24rem;
      height: 2.24rem;
      margin: 0 auto;
      background: #333;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .bottom-detail {
      padding: 0 0.14rem;
      margin-top: 0.16rem;

      .goods-title {
        height: 0.64rem;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.34rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .marks{
        margin-top: 0.1rem;
        max-height: .3rem;
        span{
          display: inline-block;
          padding: 0 0.06rem;
          font-size: 0.18rem;
          color:#ffffff;
          background: #EE2532;
          line-height: 0.28rem;
          height: 0.28rem;
          border-radius: 0.14rem;
          font-weight: bold;
        }
        &.discount{
          span{
            background: #FF7917;
          }
          
        }
        &.no-data {
          span {
            background: none;
          }
          
        }
      }
      .goods-price-block {
        margin-top: 0.06rem;

        .new-price {
          font-size: 0;
          color: #F10D3B;

          .price-sign {
            font-size: 0.18rem;
            color: #333;
            max-width: 1.4rem;
            overflow: hidden;
            white-space:nowrap;
            font-weight: bold;
            font-family: PingFangSC-Medium;
            font {
              color: #EE2532;
              font-family: DINAlternate-Bold;
              margin-left: .04rem;
            }
            .new-price-font {
              font-size: .28rem;
              font-family: DINAlternate-Bold;
              margin-left: .02rem;
            }
          }

          .old-price {
            font-size: 0.18rem;
            color: #999;
            margin-left: 0.04rem;
            max-width: .6rem;
            overflow: hidden;
            white-space:nowrap;
            .old-price-value {
              font-family: DINAlternate-Bold;
              text-decoration-line: line-through;
            }
          }
        }
      }
    }

    .buy-btn {
      width: 3.16rem;
      height: 0.48rem;
      margin: 0.11rem auto;
      background: #F10D3B;
      border-radius: 0.24rem;
      text-align: center;
      line-height: 0.48rem;
      color: #fff;
      font-size: 0.24rem;
    }
  }

  .goods-item:nth-child(3n){
    margin-right: 0;
  }
  .fixed-bar{
    display: none;
  }
}
</style>
